import styled from "styled-components";
import * as PropTypes from "prop-types";

export default function ContactDetails({ children }) {
  return (
    <UnstyledLink target="_blank" href="https://www.avadent.com/nl/assist-tandje">
      <Wrapper>{children}</Wrapper>
    </UnstyledLink>
  );
}

ContactDetails.propTypes = {
  children: PropTypes.any,
};

const UnstyledLink = styled.a`
  text-decoration: none;
`;

const Wrapper = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  text-align: left;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: 28px;

  ${({ theme }) => theme.phone`
      font-size: 22px;
  `};

  color: white;
  margin: 0;

  ${({ theme }) => theme.phone`
    margin-left: 0 !important;
  `};

  &:not(:first-child) {
    margin-left: ${({ theme }) => theme.margin}rem;
  }

  @media (max-width: 693px) {
    margin-left: 0 !important;
    text-align: right;
  }
`;
